import one from '../assets/svg/projects/one.png'
import two from '../assets/svg/projects/two.jpg'
import three from '../assets/svg/projects/three.jpg'
import four from '../assets/svg/projects/four.png'
import five from '../assets/svg/projects/five.png'
import six from '../assets/svg/projects/six.svg'
import seven from '../assets/svg/projects/seven.png'
import eight from '../assets/svg/projects/eight.svg'
import nine from '../assets/svg/projects/tatari.png'
import ten from '../assets/svg/projects/veluub.png'


export const projectsData = [
    {
          id: 7,
          projectName: 'Veluub',
          projectDesc: 'A full-stack bicycle marketplace built around trust: secure account flows, stolen bike reporting, frame-number checks, workshop booking and community features.',
          tags: ['Node.js', 'Express', 'MongoDB', 'EJS', 'JavaScript', 'Authentication', 'Security', 'Marketplace'],
          code: 'https://github.com/mvrque/veluub',
          demo: 'https://veluub.onrender.com',
          image: ten
    },
    {
        id: 6,
        projectName: 'Veterinary Clinic Website',
        projectDesc: 'Full-stack website for a veterinary clinic with service pages, contact flow and MongoDB-backed content management.',
        tags: ['HTML', 'CSS', 'JavaScript', 'Node.js', 'express', 'MongoDB', ],
        code: 'https://github.com/mvrque/vetClinicWebsite',
        demo: 'https://tataritest.netlify.app/',
        image: nine
    },
    {
        id: 4,
        projectName: 'Task Manager',
        projectDesc: 'Choose a date and add your task name and description. OOP test',
        tags: ['HTML', 'CSS', 'JavaScript'],
        code: 'https://github.com/mvrque/vetClinicWebsite',
        demo: 'https://tataritest.netlify.app/',
        image: one
    },
    {
        id: 5,
        projectName: "Booklist",
        projectDesc: 'Add your favourite books to a list. OOP test',
        tags: ['HTML', 'CSS', 'JavaScript'],
        code: 'https://github.com/mvrque/myBookList',
        demo: 'https://mvrque-booklist.netlify.app/',
        image: seven
    },
    {
        id: 2,
        projectName: 'NASA A Picture of a Day',
        projectDesc: 'This project is a random NASA A Picture of a Day generator. API test.',
        tags: ['JavaScript', 'CSS', 'HTML'],
        code: 'https://github.com/mvrque/nasaAPOD',
        demo: 'https://nasaspicoftheday.netlify.app/',
        image: two
    },
    {
        id: 4,
        projectName: 'Restaurant Website Template',
        projectDesc: 'Responsive website for your restaurant!',
        tags: ['HTML', 'CSS', 'JavaScript'],
        code: 'https://github.com/mvrque/restoranTemplate',
        demo: 'https://restaurantmakaroni.netlify.app/',
        image: four
    },
    
    
    
   
    {
        id: 3,
        projectName: 'Cocktail Generator',
        projectDesc: 'Random cocktail generator by keyword. API test',
        tags: ['JavaScript', 'CSS', 'HTML'],
        code: 'https://github.com/mvrque/cocktailAPI',
        demo: 'https://randomcocktail.netlify.app/',
        image: three
    },

    
]


// Do not remove any fields.
// Leave it blank instead as shown below

/* 
{
    id: 1,
    projectName: 'Car Pooling System',
    projectDesc: '',
    tags: ['Flutter', 'React'],
    code: '',
    demo: '',
    image: ''
}, 
*/
